import { render, staticRenderFns } from "./Fonte.vue?vue&type=template&id=281c1364&scoped=true"
import script from "./Fonte.vue?vue&type=script&lang=js"
export * from "./Fonte.vue?vue&type=script&lang=js"
import style0 from "./Fonte.vue?vue&type=style&index=0&id=281c1364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c1364",
  null
  
)

export default component.exports